import React from 'react'

const YearBodyTemplate = ({ rowData, field }) => {
    const value = rowData[field]
    return value instanceof Date ? value.getFullYear() : new Date(value, 0, 1).getFullYear()
}

export default YearBodyTemplate
